import { CategoriesTab } from './types';

export const DEFAULT_CATEGORY_TAB: CategoriesTab = 'translations';
